import { fmtPts } from "../lib/api";

const ITEMS = [
  ["points", "Punti totali", (v) => fmtPts(v)],
  ["tournaments", "Tornei"],
  ["predictions", "Pronostici"],
  ["correct", "Indovinati"],
  ["exact", "Esatti"],
  ["accuracy", "Precisione", (v) => `${Math.round(v || 0)}%`],
  ["best_rank", "Miglior posto", (v) => (v ? `#${v}` : "—")],
];

export const StatsGrid = ({ stats }) => (
  <section className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2 sm:gap-3" data-testid="stats-grid">
    {ITEMS.map(([k, label, fmt], i) => (
      <div
        key={k}
        className={`card-surface p-3 sm:p-5 fade-up ${i === 0 ? "col-span-3 md:col-span-1 border-emerald-500/40 flex md:block items-center justify-between" : ""}`}
        style={{ animationDelay: `${i * 50}ms` }}
        data-testid={`stat-${k}`}
      >
        <p className="font-mono text-[9px] sm:text-[10px] uppercase tracking-widest text-slate-400 truncate">{label}</p>
        <p className={`font-display text-2xl sm:text-4xl font-black mt-1 sm:mt-2 ${i === 0 ? "text-emerald-400 text-3xl" : ""}`}>
          {stats ? (fmt ? fmt(stats[k]) : stats[k] ?? 0) : "–"}
        </p>
      </div>
    ))}
  </section>
);
